var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"vulnModal",attrs:{"size":"xl","title":_vm.modalTitle,"hide-footer":""}},[_c('VulnerabilityTable',{attrs:{"vulnerabilities":_vm.getVulnerabilities}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }